import CoachSkillsTools from './coach-skills-tools'

export default CoachSkillsTools
